var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, width: "520px", "append-to-body": true },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.editRow.type === "add"
                ? _vm.$t("dashboard-bi::board-management::新增菜单")
                : _vm.$t("dashboard-bi::board-management::编辑菜单")
            ) +
            " "
        ),
      ]),
      _c(
        "el-radio-group",
        {
          staticClass: "form-type",
          attrs: { disabled: _vm.editRow.type === "edit" },
          on: { change: _vm.changeType },
          model: {
            value: _vm.type,
            callback: function ($$v) {
              _vm.type = $$v
            },
            expression: "type",
          },
        },
        [
          _c("el-radio", { attrs: { label: 1 } }, [
            _vm._v(_vm._s(_vm.$t("dashboard-bi::board-management::菜单"))),
          ]),
          _c("el-radio", { attrs: { label: 2 } }, [
            _vm._v(_vm._s(_vm.$t("dashboard-bi::board-management::目录"))),
          ]),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "menuform",
          attrs: {
            "label-position": "right",
            "label-width": "110px",
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _vm.type === 1
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::目录"),
                      prop: "parentId",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "no-data-text": _vm.$t(
                            "dashboard-bi::board-management::请先创建目录"
                          ),
                          disabled: !!_vm.form.sourceId,
                        },
                        model: {
                          value: _vm.form.parentId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "parentId", $$v)
                          },
                          expression: "form.parentId",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              "line-height": "60px",
                              color: "#999",
                            },
                            attrs: { slot: "empty" },
                            slot: "empty",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("dashboard-bi::board-management::请先")
                                ) +
                                " "
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeType(2)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "dashboard-bi::board-management::创建目录"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.directoryList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::菜单名称"),
                      prop: "folderName",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: !!_vm.form.sourceId },
                      model: {
                        value: _vm.form.folderName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "folderName", $$v)
                        },
                        expression: "form.folderName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::菜单类型"),
                      prop: "openType",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: _vm.editRow.type === "edit" },
                        model: {
                          value: _vm.form.openType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "openType", $$v)
                          },
                          expression: "form.openType",
                        },
                      },
                      _vm._l(_vm.openTypeList, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.form.openType === 1 ||
                (_vm.form.openType === 2 && _vm.sourceMerchantId)
                  ? [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("dashboard-bi::board-management::pc"),
                            prop: "openData",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.openData,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "openData", $$v)
                              },
                              expression: "form.openData",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard-bi::board-management::mobile"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "dashboard-bi::board-management::mobile_input_tip"
                                    ),
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconInfo-Solid iconfont tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            model: {
                              value: _vm.form.moveUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "moveUrl", $$v)
                              },
                              expression: "form.moveUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.form.openType === 2 && !_vm.sourceMerchantId
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "dashboard-bi::board-management::平台看板"
                          ),
                          prop: "boardID",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.editRow.type === "edit" },
                            model: {
                              value: _vm.form.boardID,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "boardID", $$v)
                              },
                              expression: "form.boardID",
                            },
                          },
                          _vm._l(_vm.boardList, function (item) {
                            return _c("el-option", {
                              key: item.boardID,
                              attrs: {
                                label: item.folderName,
                                value: item.boardID,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::显示排序"),
                      prop: "position",
                    },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.position,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "position", $$v)
                        },
                        expression: "form.position",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::打开方式"),
                      prop: "openTarget",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.form.openTarget,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "openTarget", $$v)
                          },
                          expression: "form.openTarget",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            value: 1,
                            label: _vm.$t(
                              "dashboard-bi::board-management::页签"
                            ),
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            value: 2,
                            label: _vm.$t(
                              "dashboard-bi::board-management::新窗口"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::目录名称"),
                      prop: "folderName",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: !!_vm.form.sourceId },
                      model: {
                        value: _vm.form.folderName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "folderName", $$v)
                        },
                        expression: "form.folderName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::显示排序"),
                      prop: "position",
                    },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.position,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "position", $$v)
                        },
                        expression: "form.position",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("dashboard-bi::board-management::选择图标"),
                      prop: "icon",
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "icon", $$v)
                          },
                          expression: "form.icon",
                        },
                      },
                      [
                        !_vm.form.sourceId
                          ? _c("i", {
                              staticClass: "el-input__icon el-icon-picture",
                              staticStyle: { cursor: "pointer" },
                              attrs: { slot: "suffix" },
                              on: {
                                click: function ($event) {
                                  _vm.showSelectIcon = !_vm.showSelectIcon
                                },
                              },
                              slot: "suffix",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.showSelectIcon && !_vm.form.sourceId
                  ? _c("el-form-item", [
                      _c(
                        "div",
                        { staticClass: "icon-list" },
                        _vm._l(_vm.iconList, function (item) {
                          return _c("i", {
                            key: item,
                            staticClass: "iconfont",
                            class: _vm.iconMapping(item),
                            on: {
                              click: function ($event) {
                                _vm.form.icon = item
                              },
                            },
                          })
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }